import { ApplicationRef, DoBootstrap, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { MsalRedirectComponent, SakerCoreModule } from 'saker-core';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppComponent } from './app.component';
import { DashboardComponent } from './Component/dashboard/dashboard.component';

import { ProjectScenariosComponent } from './Component/ProjectScenario/project-scenarios/project-scenarios.component';
import { FilterPipe } from './Pipe/filter.pipe';
import { ProjectScenarioComponent } from './Component/ProjectScenario/project-scenario/project-scenario.component';
import { ConfirmComponent } from './Component/ProjectScenario/confirm/confirm.component';
import { NoteComponent } from './Component/ProjectScenario/note/note.component';
import { LocationFileComponent } from './Component/ProjectScenario/location-file/location-file.component';
import { ProjectScenarioImportComponent } from './Component/ProjectScenario/project-scenario-import/project-scenario-import.component';

@NgModule({
  declarations: [

    FilterPipe,

    AppComponent,
    DashboardComponent,
    ProjectScenariosComponent,
    ProjectScenarioComponent,
    ConfirmComponent,
    NoteComponent,
    LocationFileComponent,
    ProjectScenarioImportComponent
  ],
  imports: [
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    BrowserAnimationsModule,
    FormsModule,
    SakerCoreModule.forRoot(environment),
  ],
  providers: [],
  bootstrap: [] //Leave empty, do bootstrap in ngDoBootstrap.
})
export class AppModule implements DoBootstrap { 

  //ngDoBootstrap is only triggered if the bootstrap array is not provided or is empty. See https://angular.io/api/core/DoBootstrap#description.
  ngDoBootstrap(appRef: ApplicationRef) {
    appRef.bootstrap(AppComponent);
    console.info('SAKER: Bootstrapped AppComponent.')
    if (SakerCoreModule.config.OAUTH) {
      appRef.bootstrap(MsalRedirectComponent);
      console.info('SAKER: Bootstrapped MsalRedirectComponent.')
    }
  }
}
